<template>
  <div
    class="d-post-multiple-choice"
    :class="{ 'can-vote': canVote }"
    @click.stop
  >
    <div
      v-if="!!activity.source.picked_option || !canVote"
      class="results"
    >
      <DuiProgressBar
        v-for="option in options"
        :key="option.key"
        color="yellow"
        :label="option.text"
        :num-votes="option.votes"
        :value="option.percentage"
      />
    </div>

    <div
      v-else
      class="multiple-choice-options"
    >
      <DuiRadioGroup
        v-if="options"
        :disabled="isVoting"
        :value="activity.source.picked_option"
        @input="voteForOption"
      >
        <template slot="options">
          <DuiOption
            v-for="option in options"
            :key="option.key"
            :text="option.text"
            :value="option.value"
          />
        </template>
      </DuiRadioGroup>
    </div>
  </div>
</template>

<script>
import pollPostMixin from '../poll-post-mixin';

export default {
  mixins: [
    pollPostMixin,
  ],
  data: () => ({
    options: null,
  }),
  mounted() {
    this.createDuiOptions();
    this.updatePercentages();
  },
  methods: {
    createDuiOptions() {
      let idx = 0;
      const options = [];

      Object.keys(this.activity.source.options_with_votes).forEach((key) => {
        options.push({
          key: `${ this.activity.slug }-op-${ idx }`,
          text: key,
          value: key,
          votes: this.activity.source.options_with_votes[key],
        });
        idx++;
      });

      this.$set(this, 'options', options);
    },

    removeCurrentVote() {
      if (!this.activity.source.picked_option) {
        return;
      }

      const op = this.options.find(o => o.value === this.activity.source.picked_option);
      this.$set(op, 'votes', op.votes - 1);
    },

    sumVoteForOption(optionValue) {
      const op = this.options.find(o => o.value === optionValue);
      this.$set(op, 'votes', op.votes + 1);
    },

    updatePercentages() {
      const totalVotes = this.options.reduce((acc, option) => acc + option.votes, 0);
      this.options.forEach((option) => {
        const optionPercentage = option.votes ?
          Math.round((option.votes / totalVotes) * 100) :
          0;
        this.$set(option, 'percentage', optionPercentage);
      });
    },

    async voteForOption(optionValue) {
      if (this.activity.source.picked_option === optionValue) {
        return;
      }

      const voteSuccessful = await this.pickPostOption(optionValue);
      if (!voteSuccessful) {
        return;
      }

      this.removeCurrentVote();
      this.sumVoteForOption(optionValue);
      this.$set(this.activity.source, 'picked_option', optionValue);
      this.updatePercentages();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-multiple-choice {
  cursor: default;
  pointer-events: none;

  &.can-vote {
    pointer-events: all;
  }

  .results {
    .dui-progress-bar {
      margin-top: $_2em;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
